import BreakdownContainer from '~/pages/IncomeCalculator/Pages/ReviewBreakdown/BreakdownContainer';
import lang from '~/pages/IncomeCalculator/Pages/ReviewBreakdown/language.json';
import SingleLineValue from '~/pages/IncomeCalculator/Pages/ReviewBreakdown/styles/SingleLineValue';
import { FormTypes } from '~/pages/IncomeCalculator/enums';
import type { CalculationResult } from '~/pages/IncomeCalculator/types';

type NoCalcCalculationBreakdownProps = {
  selectedResult: CalculationResult;
};

export default function NoCalcCalculationBreakdown({
  selectedResult,
}: Readonly<NoCalcCalculationBreakdownProps>) {
  return (
    <BreakdownContainer hideAccordion>
      <SingleLineValue
        title={lang.MONTHLY_INCOME}
        value={selectedResult.getInputAsFloat(
          FormTypes.NoCalcForm,
          0,
          'amount',
        )}
        isCurrency
      />
    </BreakdownContainer>
  );
}
